import type { TokenProps, AuthDetails } from 'tsconfig/types';

export function formatTokenResponseToAuthAtomState(token: TokenProps): AuthDetails {
  return {
    isInitialised: true,
    publicCsrf: token.csrf,
    expiryDate: token.expires_in ? new Date(Date.now() + token.expires_in) : undefined,
  };
}
